<template>
  <div>
    
    <v-card>
      <v-card-title>
        <h4>Customer</h4>
      </v-card-title>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item v-for="(value, key) in customer" :key="key">
          <v-list-item-content>{{key}}:</v-list-item-content>
          <v-list-item-content class="align-end"><input type="text" :value="value" readonly></v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {

    data() {
      return {
        returnShopPortalId: this.$route.params.returnShopPortalId,
        customer: {}
      }
    },

    mounted() {
      this.fetch().then(data => {
        const customer = this.returnShopPortal.customer

        this.customer = {
          'ID': customer.id,
          'Customer ID': customer.customerId,
          'Name': customer.customerName1,
          'OwnerId': customer.ownerId,
        }
      })
    },

    methods: {
      ...mapActions('returnShopPortal', ['fetch'])
    },

    computed: {
      ...mapState('returnShopPortal', [
        'returnShopPortal'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// Get.vue?62a1db50